import { RECURRING_RECEIVABLES_URL } from 'constants/config';
import { fetchWithAuthentication } from 'utils/fetchJson/fetchJson';

type CardTokenParams =
  | {
      apiConfirmationURL: string;
      uuidToken: string;
      sessionId?: never;
    }
  | {
      apiConfirmationURL: string;
      uuidToken?: never;
      sessionId: string;
    }
  | {
      apiConfirmationURL?: never;
      uuidToken?: never;
      sessionId?: never;
    };

export type CreateRecurringParams = {
  fingerprint?: string | null;
  locale?: string;
  scheduleId: string;
  orderId: string;
  orderToken: string;
  nonAutomated?: boolean;
  isFromGateway?: boolean;
  configurationId: string;
  clientSessionId?: string;
  captchaResponse?: string;
} & CardTokenParams;

export const recurringReceivables = {
  create: ({
    apiConfirmationURL,
    captchaResponse,
    configurationId,
    fingerprint = '',
    locale = 'EN',
    nonAutomated = false,
    orderId,
    orderToken,
    uuidToken,
    scheduleId,
    sessionId,
    isFromGateway,
    clientSessionId,
  }: CreateRecurringParams) => {
    const url = `${RECURRING_RECEIVABLES_URL}?locale=${locale}&fingerprint=${fingerprint}`;
    const body = JSON.stringify({
      order_id: orderId,
      order_token: orderToken,
      schedule_id: scheduleId,
      non_automated: nonAutomated,
      configuration_id: configurationId,
      ...(apiConfirmationURL && { api_confirmation_url: apiConfirmationURL }),
      ...(uuidToken && { uuid_token: uuidToken }),
      ...(clientSessionId && { client_session_id: clientSessionId }),
      ...(sessionId && { session_id: sessionId }),
      ...(isFromGateway && { is_from_gateway: isFromGateway }),
      ...(captchaResponse && { captcha_response: captchaResponse }),
    });

    const options = { method: 'POST', body };
    return fetchWithAuthentication<{ id: string }>(url, options);
  },
};
